<!-- src/components/BackButton.vue -->
<template>
  <button
    @click="goBack"
    title="Go Back"
    class="flex items-center justify-center p-2 rounded-full transition-colors duration-200 ease-in-out group focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent"
  >
    <!-- 
      This is the SVG for a bold, left-pointing arrow.
      The text color is set to our brand's mint green (#20FCF1).
      On hover, it will transition to the darker brand accent color.
    -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6 text-brand-mint group-hover:text-brand-accent"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="3"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  </button>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

/**
 * Navigates the user to the previous page in their history.
 * If no history is available (e.g., the page was opened in a new tab),
 * it navigates them to the main dashboard as a safe fallback.
 */
const goBack = () => {
  // This is a reliable way to check if there is a "back" location in the current session history.
  if (router.options.history.state.back) {
    router.back();
  } else {
    router.push({ name: 'dashboard' });
  }
};
</script>

<style scoped>
/* We need to define the custom brand colors here since they are not in the default Tailwind config */
.text-brand-mint {
  color: #424E5F;
}
</style>